import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        vehicles: false
      },
      options: {
        vehicles: []
      },
      selected: {
        vehicle: ''
      },
      editable: {
        vehicle: ''
      }
    }
  },

  methods: {

    async getVehicles (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.vehicle
      const fetching = context.fetching?.vehicles
      const options = context.options?.vehicles

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.vehicles = true
      context.selected.vehicle = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getVehicles(filters).then(
        ({ data }) => {
          context.options.vehicles = data
        }
      ).catch(() => {
        context.options.vehicles = []
      }).finally(() => {
        context.fetching.vehicles = false
      })
    },

    async searchVehicles (search, loading) {
      this.searchVehiclesProvider(this, search, loading)
    },

    searchVehiclesProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.vehicles, {
          keys: ['vehicle_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getVehicles(filters).then(
            ({ data }) => {
              options.vehicles = data
            }
          ).catch(() => {
            options.vehicles = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
